<template>  <!-- Split edit -->
	<section>
		<!--Toolbar -->
		<el-col :span="24" style="padding-bottom: 0px;margin-top:20px">
		  <el-form style='min-height:450px;' :model="editForm" label-width="120px" 
               :rules="editFormRules" ref="editForm">
				<el-tabs type='card' v-loading="listLoading">
          
					<!-- ----------------------------------------------------------------- -->
					<el-tab-pane> <span slot='label'><i class='el-icon-date'></i> Import</span> 

          <el-form-item label="Action:" prop="action">
            <el-select size='small' style='width:300px' v-model="action" Placeholder='Select Action'>
              <el-option v-for="item in options"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code">
                  <span style="float: left">{{ item.value }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
              </el-option>
    		    </el-select>
	  			</el-form-item>

          <el-form-item label="Site:" prop="site"  v-if="this.action=='DEL_DOSSITE' || this.action=='REB_DOSSITE' || this.action=='TAB_BACKUP' || this.action=='TAB_RESTORE'">
	  			  <el-select size='small' style='width:300px' v-model="site" Placeholder='Select Site'>
            <el-option v-for="item in sites" 
        		           :key='item.code' 
			 	               :label="item.code + ' - ' + item.name" 
			  	    				 :value='item.code'></el-option>
    		    </el-select>
	  			</el-form-item>


          <el-form-item label="Dossier:" prop="site" v-if="this.action=='DEL_ONEDOS' || this.action=='REB_ONEDOS'">
            <el-input style='width:300px;xfont-family:system;xfont-size:12px' v-model="dosid"></el-input>           
	  			</el-form-item>        

          <el-form-item label="Table:" prop="table" v-if="this.action=='TAB_BACKUP' || this.action=='TAB_RESTORE'">
            <el-select size='small' style='width:300px' v-model="table" Placeholder='Select Table'>
              <el-option v-for="item in tables"
                    :key="item.code"
                    :label="item.code"
                    :value="item.code">
              </el-option>
    		    </el-select>
	  			</el-form-item>

          <el-form-item label="Access Pin:" prop="key">
            <el-input type='password' style='margin-right:20px;width:300px;' v-model="key" show-password></el-input>           
	  			<el-button xstyle='float:right;' type='warning' size='small' icon="Upload" @click.native="Execute">Execute This Action</el-button>
	  			</el-form-item>

          <el-form-item label="Results : ">
            <el-input readonly type='textarea' rows='20' style='font-family:system;font-size:12px' v-model="results"></el-input>
          </el-form-item>
        </el-tab-pane>

					<!-- ----------------------------------------------------------------- -->
        
				</el-tabs>
        <!--
				<span style='margin-top:20px'>					
          <br/>	  	
	  			<el-button style='float:right;' type='primary' icon="Upload" @click.native="Upload">Execute</el-button>
          <el-button style='float:left;' type="default" @click.native="closeForm" icon="edit" :loading="editLoading">Cancel</el-button>
        </span>
        -->

			</el-form>
			

		</el-col>

	</section>
</template>

<script>
	import util     from '../../common/AppUtil';
  import settings from '../../common/AppSettings';
  import text     from '../../common/AppText';
  import api      from '../../api/bas/maintenance';

	export default {
	  // hideModules: { "bold": false },		
		data() {
			return {
        QID         : util.Initialize(this.$router,"MAINT"),
        util        : util,
        stack       : {},
			  lang        : text.data,
				APICode     : "maintenance",
				mainFunc    : "Generic Maintenance",
				mainSubject : "Dossier",
        mainKey     : "dosid",
				mainKeyDesc : "dosid",
        site        : "",
        action      : "",
        results     : "",
        dosid       : "",
        key         : "",
        sites : [],
        options: [],
        tables: [],
        table: "",
				data: [],    // All base/api data (Excluding generic) 
				session: {},
				content: [],
				listLoading:     false,  // Indicator list is loading
				editForm:        {},     // list of fields in the editform
				editFormVisible: false,  // Of de bewerkingsinterface wordt weergegeven
				editLoading:     false,  // Indicator edit is loading
        editMode:        '',     // ADD or SAVE mode for current rec
				editTitle:       '',     // Title of the form ('add ...' or 'modify ...')
				
				editFormRules: {         // Any form validation per field
					name: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					]
				},

			}
		},
		methods: {

      htmlData(val) {
   			var ret = "" + val;
				return ret.replace(/\\/g, '');
      },

		  // Get possible actions to present
			Initialize() {
				this.listLoading = true;

				let parg = {};
        parg.Module = "maintenance";

        api.execute("init",parg).then((res) => {					
          util.processMainResults(res);
          this.sites = util.codes.sites;
          this.options = util.getMainPayload("options");
          this.tables = util.getMainPayload("tables");
  		    this.editFormVisible = true;
          this.listLoading = false;
				});
        
			},

			// Event for submitting edit form
 	  	closeForm: function () {
         this.selectorVisible = false;
         let parg = this.stack;
         util.Forward(this.$router,"DOS",parg);
    	},	
      
      Execute: function() {
        this.listLoading = true;
        var parg = {};
        //parg.Module = "maintenance";
        parg.Params = {};
        parg.Params.site = this.site;
        parg.Params.todo = this.action;
        parg.Params.dosid = this.dosid;
        parg.Params.table = this.table;
        parg.Params.key   = this.key;

        api.execute("exec",parg).then((res) => {					
          util.processMainResults(res);
          this.results = util.getMainPayload("result");
  		    this.editFormVisible = true;
          this.listLoading = false;          
				});



      },
		},
	
		// Initial loader of data (initialize page)
		mounted() {		       
      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });
      
			this.Initialize();
		}
	}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// maintenance.vue?304a1f13